var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiAvailable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C26.2092 0 28 1.7908 28 4H30V1C30 1 30 0 31 0C32 0 32 1 32 1V4C32 4 32 6 30 6H28V10H30C32 10 32 12 32 12V15C32 15 32 16 31 16C30 16 30 15 30 15V12H28L27.9785 12.4082C27.7739 14.4256 26.0714 16 24 16H20V19H18V22H20V25H18V28H20V31H12V28H14V25H12V22H14V19H12V16H8C5.7908 16 4 14.2092 4 12H2V15C2 15 2 16 1 16C0 16 0 15 0 15V12C0 12 0 10 2 10H4V6H2C0 6 0 4 0 4V1C0 1 0 0 1 0C2 0 2 1 2 1V4H4C4 1.7908 5.7908 0 8 0H24ZM8 6V12H10V10H12V12H14V4H10L8 6ZM18 6H20V10H18V12H24V10H22V6H24V4H18V6ZM12 8H10V6H12V8Z",
    fill: "#34AC74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAvailable);
export default __webpack_public_path__ + "static/media/ai_available.9daca560765c2aa29f08d65e56942409.svg";
export { ForwardRef as ReactComponent };